import angular from 'angular';

const states = [
  { state: 'login', url: '' },
  { state: 'login.form', url: '#/login?redirectUrl' },
  { state: 'apps', url: '#/' },
  { state: 'terms', url: '#/terms' },
];

function config($stateProvider) {
  'ngInject';

  states.forEach(({ state, url }) => {
    $stateProvider.state(state, {
      url,
    });
  });
}

export default angular.module('adjust.external-routes', []).config(config).name;
